import React from 'react';
import useTheme from '../hooks/useTheme';

// Inline SVG rather than another icon package: the header only needs these two.
function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12.3 3a9 9 0 1 0 8.7 11.3 7.2 7.2 0 0 1-8.7-8.7c0-.9.1-1.8.4-2.6A9 9 0 0 0 12.3 3z"
      />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="4.6" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
        <line x1="12" y1="1.8" x2="12" y2="4.2" />
        <line x1="12" y1="19.8" x2="12" y2="22.2" />
        <line x1="1.8" y1="12" x2="4.2" y2="12" />
        <line x1="19.8" y1="12" x2="22.2" y2="12" />
        <line x1="4.8" y1="4.8" x2="6.5" y2="6.5" />
        <line x1="17.5" y1="17.5" x2="19.2" y2="19.2" />
        <line x1="4.8" y1="19.2" x2="6.5" y2="17.5" />
        <line x1="17.5" y1="6.5" x2="19.2" y2="4.8" />
      </g>
    </svg>
  );
}

export default function ThemeToggle({ onToggle }) {
  const { theme, toggle } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  const handleClick = () => {
    toggle();
    if (onToggle) onToggle(next);
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={handleClick}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
